import React, { Component } from "react";
import PropTypes from "prop-types";
import Cover, { CoverProps } from "@/read-ui/Cover";
import { bookcover } from "@/utils/URL";
import RatingLabel from "@/components/Book/Rating/RatingLabel";
import styles from "./styles.module.scss";
import cover_chereads from "@/assets/theme/imgPh.png";

export type BookCoverProps = {
  bookInfo: {
    bookId?: string;
    coverId?: string | number;
  };
} & Partial<CoverProps>;

const BookCover = (props: BookCoverProps) => {
  const { bookInfo, width = 52, src, ...restProps } = props;
  const { bookId = "", coverId } = bookInfo;

  const coverUrl = bookcover(bookId, width * 2, coverId);

  return <Cover src={coverUrl} width={width} {...restProps}></Cover>;
};

export default BookCover;
